import { useState } from "react";
import API_URL from "../config";

const PRESET_COLORS = [
  { label: "Vert",   value: "#1a7a3c" },
  { label: "Rouge",  value: "#cc1f1f" },
  { label: "Bleu",   value: "#1a2756" },
  { label: "Or",     value: "#f5c200" },
  { label: "Orange", value: "#C6582C" },
  { label: "Violet", value: "#6E4F9E" },
];

export default function AdminForm({ onAdd }) {
  const [titre, setTitre]         = useState("");
  const [contenu, setContenu]     = useState("");
  const [details, setDetails]     = useState("");
  const [badge, setBadge]         = useState("");
  const [badgeColor, setBadgeColor] = useState("#1a7a3c");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!titre || !contenu) return;

    try {
      const res = await fetch(`${API_URL}/api/info`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ titre, contenu, details, badge, badgeColor }),
      });

      if (!res.ok) {
        const err = await res.json();
        alert("Erreur serveur : " + err.message);
        return;
      }

      setTitre(""); setContenu(""); setDetails("");
      setBadge(""); setBadgeColor("#1a7a3c");
      onAdd();

    } catch (err) {
      alert("Impossible de contacter le serveur.");
      console.error(err);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">

      <input type="text" placeholder="Titre" value={titre}
        onChange={(e) => setTitre(e.target.value)}
        className="w-full p-2 border rounded" required />

      <textarea placeholder="Contenu" value={contenu}
        onChange={(e) => setContenu(e.target.value)}
        className="w-full p-2 border rounded" required />

      <textarea placeholder="Détails (visible via bouton)" value={details}
        onChange={(e) => setDetails(e.target.value)}
        className="w-full p-2 border rounded" />

      {/* Badge */}
      <div className="p-3 rounded-lg border border-gray-200 bg-gray-50 space-y-3">
        <p className="font-bold text-sm text-gray-700">🏷️ Badge (optionnel)</p>

        <input type="text" placeholder='Ex: Nouveau, Ouverture, Urgent…'
          value={badge} onChange={(e) => setBadge(e.target.value)}
          className="w-full p-2 border rounded text-sm" maxLength={20} />

        {badge && (
          <div>
            <p className="text-xs text-gray-500 mb-2">Couleur du badge :</p>
            <div className="flex flex-wrap gap-2 mb-2">
              {PRESET_COLORS.map((c) => (
                <button type="button" key={c.value}
                  onClick={() => setBadgeColor(c.value)}
                  style={{
                    background: c.value, color: "#fff",
                    border: badgeColor === c.value ? "3px solid #111" : "2px solid transparent",
                    borderRadius: 20, padding: "4px 12px",
                    fontWeight: 700, fontSize: "0.75rem", cursor: "pointer",
                  }}>
                  {c.label}
                </button>
              ))}
            </div>
            {/* Couleur personnalisée */}
            <div className="flex items-center gap-2">
              <input type="color" value={badgeColor}
                onChange={(e) => setBadgeColor(e.target.value)}
                style={{ width: 34, height: 34, border: "2px solid #ccc", borderRadius: 8, cursor: "pointer" }} />
              <span className="text-xs text-gray-500">Personnalisée</span>
            </div>
            {/* Aperçu */}
            <div className="mt-2 flex items-center gap-2">
              <span className="text-xs text-gray-500">Aperçu :</span>
              <span style={{
                background: badgeColor, color: "#fff",
                fontWeight: 700, fontSize: "0.72rem", textTransform: "uppercase",
                letterSpacing: "0.08em", padding: "4px 12px", borderRadius: 20,
                border: "2px solid #111",
              }}>{badge}</span>
            </div>
          </div>
        )}
      </div>

      <button type="submit"
        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        Ajouter
      </button>

    </form>
  );
}
